import { TableOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { asyncSelectWidgetObjectName } from '../async-select/hooks/asyncSelectObjectName';
import { AsyncTableConfigComponent } from './AsyncTableConfigComponent';
import { AsyncTableConfigSchema } from './AsyncTableConfigSchema';
import { AsyncTableWidgetComponent } from './AsyncTableWidgetComponent';
import { AsyncTableWidgetPreview } from './AsyncTableWidgetPreview';
import { createAsyncTableFormSchema } from './createAsyncTableSchema';
import { IAsyncTableWidget } from './IAsyncTableWidget';

export const AsyncTableWidgetType: IWidgetType<IAsyncTableWidget> = {
  type: WidgetType.AsyncTable,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Advanced,
  name: 'Tabella da servizio',
  icon: <TableOutlined />,
  hasValue: false,
  formComponent: AsyncTableWidgetComponent,
  createFormSchema: createAsyncTableFormSchema,
  previewComponent: AsyncTableWidgetPreview,
  configValidator: AsyncTableConfigSchema,
  configComponent: AsyncTableConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [],
  /**
   * Per le async select nell'hydrate ritorno, come valore
   * non il value del widget, ma la label mostrata all'utente,
   * così da poter valorizzare correttamente il pdf.
   */
  hydrate: ({ context, path, widget }) => {
    try {
      // Recupero la chiave <path>@object
      const objectKey = asyncSelectWidgetObjectName(path);
      const values = get(context.values, objectKey);

      // Lo ritorno, il campo andrà a sovrascrivere il valore ritornato.
      return {
        value: values,
      };
    } catch (error) {
      console.error(`[AsyncTableWidgetType] Errore durante l'hydrate del widget ${path}`, { context, path, widget, error }); // prettier-ignore
      return {
        value: [],
      };
    }
  },
};
